import { focusVisible, forcedColorsStylesheetBehavior } from "@microsoft/fast-foundation";
import { neutralForegroundHint } from "@fluentui/web-components";
import { css } from "@microsoft/fast-element";
import { SystemColors } from "@microsoft/fast-web-utilities";
/** Style definitions for the ActionsMenu web component */
export const actionMenuStyles = css `
    :host {
        z-index: 3;
    }

    :host(:focus) {
        outline: none;
    }

    :host([isWindowsDashboard]) {
        --control-corner-radius: 8;
    }

    fluent-menu {
        box-shadow: 0 2.4px 7.2px rgba(0, 0, 0, 0.18), 0 12.8px 28.8px rgba(0, 0, 0, 0.22);
        max-width: var(--menu-max-width, 275px);
        min-width: var(--menu-min-width, 240px);
        forced-color-adjust: auto;
        z-index: 2;
    }

   svg {
        fill: currentColor;
    }

    .icon {
        align-items: center;
        display: flex;
    }

    :host(:${focusVisible}) {
        outline: none;
    }

    fluent-menu-item::part(content) {
        width: 100%;
        overflow: none;
    }

    .menu-item {
        grid-template-columns: minmax(32px, auto) 1fr minmax(32px, auto);
    }

    .menu-item-divider {
        margin-bottom: 6px;
    }
    .menu-item-text {
        padding-inline-start: 12px;
        color: ${neutralForegroundHint};
        font-size: 12px;
    }
`.withBehaviors(forcedColorsStylesheetBehavior(css `
            .menu-item[isNavigation] {
                color: ${SystemColors.LinkText};
            }

            .menu-item[isNavigation]:hover {
                color: ${SystemColors.HighlightText};
            }
        `));
